import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircleIcon, ArrowLeftIcon, CreditCardIcon } from '@heroicons/react/24/solid';

const SubscriptionCancelled: React.FC = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate('/signup');
  };

  const handleGoBack = () => {
    navigate('/pricing');
  };

  const handleContactSupport = () => {
    window.location.href = 'mailto:support@blockboardapp.com?subject=Subscription Support';
  };

  return (
    <div className="min-h-screen bg-background-900 text-white">
      <div className="max-w-4xl mx-auto px-6 py-20">
        <div className="text-center">
          {/* Cancelled Icon */}
          <div className="mx-auto w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mb-8">
            <XCircleIcon className="w-16 h-16 text-red-600" />
          </div>

          {/* Cancelled Message */}
          <h1 className="text-4xl font-bold mb-4">
            Subscription Cancelled
          </h1>
          <p className="text-xl text-gray-300 mb-8">
            Your payment was cancelled and no charges were made
          </p>

          {/* Information Box */}
          <div className="bg-background-800 rounded-lg p-6 mb-8 max-w-md mx-auto">
            <h3 className="text-lg font-semibold mb-4">What Happened?</h3>
            <div className="text-left space-y-3">
              <p className="text-gray-300">
                • Your payment process was interrupted or cancelled
              </p>
              <p className="text-gray-300">
                • No charges have been made to your card
              </p>
              <p className="text-gray-300">
                • You can try again at any time
              </p>
            </div>
          </div>

          {/* Common Issues & Solutions */}
          <div className="bg-background-800 rounded-lg p-6 mb-8">
            <h3 className="text-lg font-semibold mb-4">Common Issues & Solutions</h3>
            <div className="grid md:grid-cols-2 gap-4 text-left">
              <div className="space-y-2">
                <h4 className="font-medium text-yellow-400">Payment Method Issues</h4>
                <ul className="text-sm text-gray-400 space-y-1">
                  <li>• Check card details and expiry date</li>
                  <li>• Ensure sufficient funds are available</li>
                  <li>• Try a different payment method</li>
                </ul>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-blue-400">Browser Issues</h4>
                <ul className="text-sm text-gray-400 space-y-1">
                  <li>• Disable ad blockers temporarily</li>
                  <li>• Clear browser cache and cookies</li>
                  <li>• Try a different browser</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button
              onClick={handleRetry}
              className="group bg-accent-600 hover:bg-accent-700 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2"
            >
              <CreditCardIcon className="w-5 h-5" />
              <span>Try Again</span>
            </button>
            
            <button
              onClick={handleGoBack}
              className="group bg-background-700 hover:bg-background-600 text-white font-bold py-3 px-6 rounded-lg border border-accent-600 transition-colors duration-200 flex items-center justify-center space-x-2"
            >
              <ArrowLeftIcon className="w-5 h-5" />
              <span>Back to Pricing</span>
            </button>
          </div>

          {/* Support Section */}
          <div className="bg-background-800 rounded-lg p-6">
            <h3 className="text-lg font-semibold mb-4">Still Need Help?</h3>
            <p className="text-gray-300 mb-4">
              If you continue to experience issues, our support team is here to help.
            </p>
            <button
              onClick={handleContactSupport}
              className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200"
            >
              Contact Support
            </button>
          </div>

          {/* Fine Print */}
          <p className="text-xs text-gray-500 mt-8">
            Your account information has been saved. You can complete your subscription at any time.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancelled;